import { render } from "./TenantEngagements.vue?vue&type=template&id=a58ffa74&ts=true"
import script from "./TenantEngagements.vue?vue&type=script&lang=ts"
export * from "./TenantEngagements.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__